import { Table, TableColumnsType } from 'antd'
import { useTheme } from 'antd-style'
import { useMemo } from 'react'

import { GetSimeTbTreatmentPlanResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  data?: GetSimeTbTreatmentPlanResponse
}

export const SimeTBTreatmentsConsumablesTables = ({ data }: Props) => {
  const { t } = useLocales()

  const palette = useTheme()

  const medicines = data?.prescribedTreatments || []

  const columns: TableColumnsType = useMemo(
    () => [
      {
        key: 'name',
        title: t('consultations.active_substance'),
        render: (_, { internationalName }) => {
          const name = internationalName?.name
          const prefixes = internationalName?.activeSubstances?.map(
            (substance: { prefix: string }) => substance?.prefix
          )

          const prefixLabel = (prefixes ?? [])
            .filter((p: string) => p?.trim() !== '')
            .join('+')

          const fullLabel = `${name} ${prefixLabel ? `(${prefixLabel})` : ''}`

          return <Text>{fullLabel}</Text>
        }
      },

      {
        key: 'um',
        title: t('common.unit'),
        dataIndex: ['productForm', 'name']
      },
      {
        key: 'amount',
        width: '20%',
        title: t('common.quantity'),
        dataIndex: 'amountPerDay'
      }
    ],
    [t, palette]
  )

  return (
    <Table
      dataSource={medicines}
      rowKey="name"
      scroll={{ x: 'max-content' }}
      columns={columns}
      pagination={false}
    />
  )
}
